'use strict';

module.exports = new Function("return this")();



//////////////////
// WEBPACK FOOTER
// ./~/es5-ext/global.js
// module id = 8
// module chunks = 0